import React, { useState } from 'react';
// @ts-ignore
import styles from './SignatureFirstLogin.module.scss';
import { joinClasses } from '../../Utils/className.util';
import SignatureCanvas from 'react-signature-canvas';
import LinkButton from '../Button/LinkButton';
import apiClient from '../../Services/ApiClient';
import Loading from '../Loading';
import { useAppContext } from '../../Services/AppContext';
import FirstUpper from '../FirstUpper';
import Button from '../Button/Button';
import { useEffectAsync } from '../../helpers';
import netteApiClient from '../../Services/NetteApiClient';

interface SignatureFirstLoginProps {
	userId: string;
	continueUrl: string;
}

export default function SignatureFirstLogin(props: SignatureFirstLoginProps) {
	const { userId, continueUrl } = props;
	const [activeTab, setActiveTab] = useState('draw');
	const [sigCanvas, setSigCanvas] = useState(null);
	const [imageData, setImageData] = useState(null);
	const { translation } = useAppContext();
	const [signatureData, setSignatureData] = useState(null);

	const handleSaveDraw = () => {
		const canvas = sigCanvas.getTrimmedCanvas();
		// @ts-ignore
		canvas.toBlob(async blob => {
			// save
			const formData = new FormData();
			formData.append('files[]', blob);
			await apiClient.postMultipart(
				'/doctors/' + userId + '/signature',
				formData,
			);

			// preview
			// await loadSignature(); // pokud to tam dam ihned, s3 ještě vrací 404, musí se chvíli počkat, tak to ojebem fejkem
			setImageData(canvas.toDataURL('image/png'));
			setActiveTab('current');
		}, 'image/png');
	};

	// @ts-ignore
	useEffectAsync(async () => {
		if (!signatureData) {
			const response = await apiClient.get(
				'/doctors/' + userId + '/signature-text',
			);
			setSignatureData(response.data);
		}
	});

	return (
		<div>
			{activeTab === 'current' && (
				<div className={joinClasses([styles.textTab, styles.tab])}>
					{imageData === null && (
						<div className={'py-5'}>
							<Loading />
						</div>
					)}
					<div className={styles.signature}>
						<div className={styles.image}>
							{imageData && <img src={imageData} alt={'current signature'} />}
						</div>
						<div className={styles.text}>
							{signatureData && (
								<>
									{signatureData.fullName}
									<br />
									{signatureData.identificationDocument?.type && (
										<>
											{signatureData.identificationDocument.type}:{' '}
											{signatureData.identificationDocument.number}
											<br />
										</>
									)}
									<br />
									<FirstUpper>
										{translation['component.signature.electronicallyGenerated']}
									</FirstUpper>
									<br />
									<FirstUpper>
										{translation['component.signature.place']}
									</FirstUpper>
									: {signatureData.address}
									<br />
									<FirstUpper>
										{translation['component.signature.date']}
									</FirstUpper>
									: {signatureData.date}
									<br />
									<FirstUpper>
										{translation['component.signature.time']}
									</FirstUpper>
									: {signatureData.time}{' '}
									{translation['component.signature.hours']}
								</>
							)}
						</div>
					</div>
					<div
						className={joinClasses([styles.controls, styles.controlsColumn])}
					>
						<Button
							onClick={() => {
								netteApiClient.get(continueUrl);
							}}
							title={translation['base.shared.continue']}
							theme={'green'}
							className={''}
						/>
						<br />
						<LinkButton
							onClick={() => {
								setActiveTab('draw');
							}}
							title={translation['component.signature.startAgain']}
							theme={'red'}
						/>
					</div>
				</div>
			)}
			{activeTab === 'draw' && (
				<div className={joinClasses([styles.tab, styles.textTabWithCanvas])}>
					<p>
						<FirstUpper>
							{translation['component.signature.drawDescription']}
						</FirstUpper>
					</p>
					<SignatureCanvas
						SpenColor='black'
						canvasProps={{
							width: 552,
							height: 300,
							className: styles.sigCanvas,
						}}
						ref={ref => {
							setSigCanvas(ref);
						}}
					/>
					<div className={styles.controls}>
						<LinkButton
							onClick={() => {
								sigCanvas.clear();
							}}
							title={translation['component.signature.startAgain']}
							theme={'red'}
						/>
						<Button
							onClick={handleSaveDraw}
							title={translation['base.shared.save']}
							theme={'blue'}
							className={''}
						/>
					</div>
				</div>
			)}
		</div>
	);
}
